import axios from 'axios';
import { RepositoryFactory } from 'shared/repositories/RepositoryFactory'

const PoisRepository = RepositoryFactory.get('pois');

const state = {
  pois: [],
  tooltip: {
    visible: false,
    coordinates: null,
    poi: null
  }
}

const actions = {
  getPois ({ commit }, queries) {
    return new Promise((resolve, reject) => {
      const requests = [];

      // Create multiple axios get requests and store in an Array..
      queries.forEach((queryParams) => requests.push(PoisRepository.getPois(queryParams)))

      // Call axios all to handle all requests
      axios.all(requests).then(axios.spread((...responses) => {
        let data = [];

        // Iterate all responses and push to data Array...
        responses.forEach((response, index) => {
          if (response.status === 200 && response.data.data) {
            data = [...data, ...response.data.data]
          }
        });

        commit('SET_POIS', data);
        resolve(data);
      }))
        .catch(error => reject(error));
    });
  },
  setMarkerPoiTooltip ({ commit }, tooltip) {
    commit('SET_MARKER_POI_TOOLTIP', tooltip);
  },
  storeBounds ({ commit }, bounds) {
    commit('SET_BOUNDS', bounds);
  }
}

const mutations = {
  SET_POIS (state, pois) {
    state.pois = pois;
  },
  SET_MARKER_POI_TOOLTIP (state, tooltip) {
    state.tooltip = tooltip;
  },
  SET_BOUNDS (state, bounds) {
    state.bounds = bounds
  }
}

const getters = {
  getPois: state => state.pois,
  getPoiTooltip: state => state.tooltip,
  getBounds: state => state.bounds
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
